import axios from "axios";
import { language } from "./language";

// export const webUrl = 'http://localhost:8000/v1/'
export const webUrl = 'https://d1p91tziu2biez.cloudfront.net/v1/'

// export const monuments = [
//   {
//     imgId: "/assets/images/frame/jpg/01_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/01_Gu.jpg",
//     name: "Historic Sardar Sarovar Dam",
//     name_gu: "ઐતિહાસિક સરદાર સરોવર ડેમ",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/02_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/02_Gu.jpg",
//     name: "Gujarat’s Lifeline Narmada Canal Network",
//     name_gu: "ગુજરાતની જીવાદોરી નર્મદા નહેર નેટવર્ક",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/03_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/03_Gu.jpg",
//     name: "World’s Tallest Monument Statue of Unity",
//     name_gu:
//       "વિશ્વની સૌથી ઊંચી પ્રતિમા સ્ટેચ્યુ ઑફ યુનિટી",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/04_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/04_Gu.jpg",
//     name: "India’s First Riverfront Sabarmati Riverfront",
//     name_gu: "ભારતનો પહેલો સાબરમતી રિવરફ્રંટ",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/05_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/05_Gu.jpg",
//     name: "Gujarat’s First Metro Rail",
//     name_gu: "ગુજરાતની પહેલી મેટ્રો રેલ",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/06_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/06_Gu.jpg",
//     name: "World’s Largest Cricket Stadium Narendra Modi Stadium",
//     name_gu:
//       "વિશ્વનું સૌથી વિશાળ ક્રિકેટ સ્ટેડિયમ નરેન્દ્ર મોદી સ્ટેડિયમ",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/07_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/07_Gu.jpg",
//     name: "India’s First Finance Tech City GIFT City",
//     name_gu:
//       "ભારતનું પહેલું ફાયનાન્સ ટેક સીટી ગિફ્ટ સીટી",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/08_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/08_Gu.jpg",
//     name: "Smritivan Earthquake Memorial & Museum Honouring the Spirit of Resilience",
//     name_gu:
//       "સ્મૃતિવન ભૂકંપ મેમોરિયલ અને મ્યુઝિયમ અડીખમ ગુજરાતનું પ્રતિક",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/09_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/09_Gu.jpg",
//     name: "Kutch Hybrid Energy Park World’s Largest Hybrid Energy Park",
//     name_gu:
//       "કચ્છ હાઈબ્રિડ એનર્જી પાર્ક વિશ્વનો સૌથી વિશાળ હાઈબ્રિડ એનર્જી પાર્ક",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/10_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/10_Gu.jpg",
//     name: "Gujarat’s First Science City",
//     name_gu: "ગુજરાતનું પહેલું સાયન્સ સીટી",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/11_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/11_Gu.jpg",
//     name: "Seema Darshan Nada Bet",
//     name_gu: "સીમા દર્શન નાડા બેટ",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/12_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/12_Gu.jpg",
//     name: "Girnar Ropeway",
//     name_gu: "ગિરનાર રોપવે",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/13_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/13_Gu.jpg",
//     name: "Surat’s Multi-level Flyover India’s Growth Engine Gujarat",
//     name_gu:
//       "સુરતનો મલ્ટી લેવલ ફ્લાયઓવર ભારતનું ગ્રોથ એન્જિન ગુજરાત",
//   },
//   {
//     imgId: "/assets/images/frame/jpg/14_English.jpg",
//     imgId_gu: "/assets/images/frame/jpg/14_Gu.jpg",
//     name: "Gujarat’s Ports India’s Growth Engine Gujarat",
//     name_gu:
//       "ગુજરાતના બંદરો ભારતનું ગ્રોથ એન્જિન ગુજરાત",
//   },
// ];

export const monuments = [
  {
    imgId: "/assets/images/frame/vikshitbharatframes/1.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Houses built under PM Awas Yojana",
    name_gu: "ઐતિહાસિક સરદાર સરોવર ડેમ",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/2.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Ayushman Arogya Mandir",
    name_gu: "ગુજરાતની જીવાદોરી નર્મદા નહેર નેટવર્ક",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/3.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Statue of Unity, Gujarat",
    name_gu:
      "વિશ્વની સૌથી ઊંચી પ્રતિમા સ્ટેચ્યુ ઑફ યુનિટી",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/4.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Kashi Vishwanath Dham, Uttar Pradesh",
    name_gu: "ભારતનો પહેલો સાબરમતી રિવરફ્રંટ",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/5.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Pradhan Mantri Bhartiya Janaushadhi Kendra",
    name_gu: "ગુજરાતની પહેલી મેટ્રો રેલ",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/6.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Izzat Ghar, Swachh Bharat Mission",
    name_gu:
      "વિશ્વનું સૌથી વિશાળ ક્રિકેટ સ્ટેડિયમ નરેન્દ્ર મોદી સ્ટેડિયમ",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/7.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "New Parliament House, New Delhi",
    name_gu:
      "ભારતનું પહેલું ફાયનાન્સ ટેક સીટી ગિફ્ટ સીટી",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/8.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "National War Memorial, New Delhi",
    name_gu:
      "સ્મૃતિવન ભૂકંપ મેમોરિયલ અને મ્યુઝિયમ અડીખમ ગુજરાતનું પ્રતિક",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/9.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Central Vista, New Delhi",
    name_gu:
      "કચ્છ હાઈબ્રિડ એનર્જી પાર્ક વિશ્વનો સૌથી વિશાળ હાઈબ્રિડ એનર્જી પાર્ક",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/10.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Atal Tunnel, Himachal Pradesh",
    name_gu: "ગુજરાતનું પહેલું સાયન્સ સીટી",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/11.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Vande Bharat Express",
    name_gu: "સીમા દર્શન નાડા બેટ",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/12.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Bundelkhand Expressway, Uttar Pradesh",
    name_gu: "ગિરનાર રોપવે",
  },
  {
    imgId: "/assets/images/frame/vikshitbharatframes/13.jpg",
    imgId_gu: "/assets/images/frame/vikshitbharatframes/1.jpg",
    name: "Chenab Rail Bridge, Jammu & Kashmir",
    name_gu:
      "સુરતનો મલ્ટી લેવલ ફ્લાયઓવર ભારતનું ગ્રોથ એન્જિન ગુજરાત",
  }
];
export const textmapping = (text, bhasa) => {
  let lang = bhasa ? bhasa : "en";
  let lan = language[lang];
  // console.log(lan);
  if (lan && lan[text]) {
    text = lan[text];
  }
  return text;
};

export const getDeviceType = () => {
  try {
    const ua = navigator.userAgent;
    console.log(ua);
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "mobile";
    }
    if (/Mobile|iP(hone|od)/.test(ua)) {
      return;
    }
  } catch (er) {
    return "desktop";
  }
  return "desktop";
};

export const deviceName = () => {
  let device = "";
  try {
    if (
      window.location.href.indexOf("view=web") !== -1 ||
      localStorage.getItem("org_url").indexOf("view=web") !== -1
    ) {
      device = "desktop";
    } else if (
      window.location.href.indexOf("appversionios") !== -1 ||
      localStorage.getItem("org_url").indexOf("appversionios") !== -1
    ) {
      device = "iosapp";
    } else if (
      window.location.href.indexOf("appversionandroid") !== -1 ||
      localStorage.getItem("org_url").indexOf("appversionandroid") !== -1
    ) {
      device = "androidapp";
    } else {
      device = "pwa";
    }
  } catch (error) { }
  return device;
};

export function iOS() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

export const dataURLToBlob = function (dataURL) {
  var BASE64_MARKER = ";base64,";
  var parts = "";
  var contentType = "";
  var raw = "";
  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    parts = dataURL.split(",");
    contentType = parts[0].split(":")[1];
    raw = parts[1];
    return new Blob([raw], { type: contentType });
  }
  parts = dataURL.split(BASE64_MARKER);
  contentType = parts[0].split(":")[1];
  raw = window.atob(parts[1]);
  var rawLength = raw.length;
  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};

export default monuments;

var API_URL = "https://campaign-api.narendramodi.in/har_ghar_tiranga";

export const PeopleWallApi = async (data) => {
  let req = await axios({
    method: "POST",
    headers: { "Content-Type": "application/json" },
    url: API_URL,
    data: data,
  });

  return req;
};

export const ShareCountApi = async (data) => {
  let req = await axios({
    method: "POST",
    headers: { "Content-Type": "application/json" },
    url: API_URL,
    data: data,
  });

  return req;
};

export const backgroundRemoval = async (file) => {
  // const encodedParams = new URLSearchParams();
  // encodedParams.append("url", url);

  // const options = {
  //   method: "POST",
  //   headers: {
  //     "content-type": "application/x-www-form-urlencoded",
  //     "X-RapidAPI-Key": "76c8e9157dmsh8257b29082efa64p185f21jsn36c593135c60",
  //     "X-RapidAPI-Host": "background-removal4.p.rapidapi.com",
  //   },
  //   body: encodedParams,
  // };
  // $(".preloader_bg").show();

  // let response = await fetch(
  //   "https://background-removal4.p.rapidapi.com/v1/results?mode=fg-image",
  //   options
  // );
  // .then(response => response.json())
  // .then(response => { console.log(response.results[0].entities[0].image) })
  // .catch(err => console.error(err));

  var formdata = new FormData();
  formdata.append("file", file);

  var requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
  };

  let response = await fetch(
    "https://api.modistory.in/v1/articlecategory/upload-cloud-image2",
    // `${webUrl}image/upload-cloud-image`,
    requestOptions
  );
  let json = await response.json();

  json = json.data;

  return json;
};


export const appShareTextString = (text) => {
  // text = text ? text.split("'").join("") : "";
  text = text ? text.split("‘").join("'") : "";
  text = text ? text.split("’").join("'") : "";
  text = text ? text.split("‟").join('"') : "";
  text = text ? text.split("“").join('"') : "";
  text = text ? text.split("❝").join('"') : "";
  text = text ? text.split("❞").join('"') : "";
  text = text ? text.split("”").join('"') : "";
  text = text ? text.split("„").join('"') : "";
  return text;
};

export function base64toBlob(base64Data, contentType) {
  contentType = contentType || "";
  var sliceSize = 1024;
  var byteCharacters = atob(base64Data);
  var bytesLength = byteCharacters.length;
  var slicesCount = Math.ceil(bytesLength / sliceSize);
  var byteArrays = new Array(slicesCount);

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    var begin = sliceIndex * sliceSize;
    var end = Math.min(begin + sliceSize, bytesLength);

    var bytes = new Array(end - begin);
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}


export const doRequest = async (data, method, action, loader, self) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  if (data) {
    var raw = JSON.stringify(data);
  }
  var requestOptions = {
    method: method ? method : "POST",
    headers: myHeaders,
    redirect: "follow",
  };
  if (method === "POST") {
    requestOptions["body"] = raw;
  }
  let response = await fetch(
    `${self ? self : webUrl}${action}`,
    requestOptions
  );
  let result = await response.json();

  return result;
};